import RichText from '/react4xp/components/prototype/RichText'

import type { EventAgendaProps, SpeakerCard, AgendaItem } from './types'

export default function EventAgenda({ speakersTitle, speakers = [], agendaTitle, agendaItems = [] }: EventAgendaProps) {
	if (agendaItems.length === 0) {
		return null
	}

	const hasSpeakers = speakers.length > 0

	return (
		<section className="my-16">
			<div className="container">
				<div className="grid grid-cols-12 gap-x-8 gap-y-0">

					{hasSpeakers && (
						<div className="col-span-12 lg:col-span-6 xl:col-span-4 order-2 lg:order-1 mt-8">
							{speakersTitle && <h2 className="h3 text-black-950">{speakersTitle}</h2>}

							<div className="flex flex-col gap-3 mt-6">
								{speakers.map((speaker, i) => (
									<SpeakerRow key={i} {...speaker} />
								))}
							</div>
						</div>
					)}

					<div className={`bg-brand-50 p-8 ${hasSpeakers ? 'col-span-12 lg:col-span-6 xl:col-span-8 order-1 lg:order-2' : 'col-span-12 order-1'}`}>
						{agendaTitle && <h2 className="h3 text-black-950 mb-6">{agendaTitle}</h2>}

						<div className="flex flex-col">
							{agendaItems.map((item, i) => (
								<AgendaRow key={i} {...item} />
							))}
						</div>
					</div>

				</div>
			</div>
		</section>
	)
}

function SpeakerRow({ photo, name, subtitle }: SpeakerCard) {
	return (
		<div className="flex gap-4">
			{photo && (
				<figure className="w-23.5 h-23.5 max-w-full rounded-full overflow-hidden shrink-0">
					<img src={photo.src} alt={photo.alt} className="w-full h-full object-cover" />
				</figure>
			)}

			<div className="flex flex-col gap-1">
				<p className="body-small font-bold text-black-950">{name}</p>
				{subtitle && <p className="body-small text-black-950">{subtitle}</p>}
			</div>
		</div>
	)
}

function AgendaRow({ time, title, richText }: AgendaItem) {
	return (
		<div className="py-3 border-b border-black-100">
			<div className="flex flex-col gap-1.75">
				{time && <p className="body text-black-950">{time}</p>}
				{title && <h3 className="h5 text-black-950">{title}</h3>}
				{richText && <RichText>{richText}</RichText>}
			</div>
		</div>
	)
}
